import { render, staticRenderFns } from "./analises.vue?vue&type=template&id=bc80a2b2&scoped=true"
import script from "./analises.vue?vue&type=script&lang=js"
export * from "./analises.vue?vue&type=script&lang=js"
import style0 from "./analises.vue?vue&type=style&index=0&id=bc80a2b2&prod&lang=css"
import style1 from "./analises.vue?vue&type=style&index=1&id=bc80a2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc80a2b2",
  null
  
)

export default component.exports